import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { map, tap } from "rxjs/operators";

@Injectable()
export class DealershipGroupService {
  constructor(private http: HttpClientService) {}

  public getGroups(): Observable<any> {
    return this.http
      .get("/api/dealership_groups")
      .pipe(tap((_) => console.log("DealershipGroupService.getGroups: Ok.")));
  }

  public show(id: number): Observable<any> {
    return this.http
      .get("/api/dealership_groups/" + id)
      .pipe(tap((_) => console.log("DealershipGroupService.show: Ok.")));
  }

  public filterByStatus(status): Observable<any> {
    const options = {
      params: {
        status: status,
      },
    };
    return this.http
      .get("/api/dealership_groups/filter_by_status", options)
      .pipe(tap((_) => console.log("DealershipGroupService.filterByStatus: Ok.")));
  }

  public addDealershipGroup(data): Observable<any> {
    return this.http
      .post("/api/dealership_groups", data)
      .pipe(tap((_) => console.log("DealershipGroupService.addDealershipGroup: Ok.")));
  }

  public updateDealershipGroup(data): Observable<any> {
    return this.http
      .put("/api/dealership_groups/" + data.id, data)
      .pipe(tap((_) => console.log("DealershipGroupService.updateDealershipGroup: Ok.")));
  }
}
